<div [id]="blogContainerId">
  <app-small-header bgColor="white"></app-small-header>
  <div class="blog-tag-container">
    <app-hero-banner heading="{{ tag + ' Travel Blogs' }}"></app-hero-banner>
  </div>
  <div>
    <div class="container">
      <!-- BREADCRUMB -->
      <nav aria-label="breadcrumb" class="mb-2 mt-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
          <li class="breadcrumb-item"><a routerLink="/blog">Blog</a></li>
          <li class="breadcrumb-item text-muted active" aria-current="page">
            {{ tag || "Tag" }}
          </li>
        </ol>
      </nav>
      <div class="mt-4">
        <hr />
        <div class="result-count">Showing: {{ totalCount }} Results</div>
      </div>
      <div class="card-container mt-3">
        @for(item of latestBlogs; track $index){
        <app-single-blog-card
          [item]="item"
          [showDescription]="false"
        ></app-single-blog-card>
        }
      </div>
      @if (latestBlogs.length < totalCount) {
      <div class="text-center mt-5">
        <app-button type="secondary" (click)="loadMoreBlogs()"
          >Load More</app-button
        >
      </div>
      }
    </div>
    <div class="mt-5"><app-expanded-themes /></div>
  </div>
</div>
